




















































import {
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import AnnouncementModule from '@/store/modules/Announcement';
import LanguageButton from '@/components/LanguageButton.vue';
import MobileButton from '@/components/MobileButton.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import jwt_decode from 'jwt-decode';
import DocumentButton from '@/components/DocDownload.vue';
import Vue from 'vue';

@Component({
  components: {
    LanguageButton,
    MobileButton,
    DocumentButton,
  },
})
export default class Nav extends Mixins(ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  AnnouncementInstance = getModule(AnnouncementModule, this.$store);

  AnnounceList = [];

  dateNow: any;

  expJwt: any;

  jwtExpx: any;

  textAnnouncement: any;

  @Prop() readonly toggleSidebar!: Function;

  async created() {
    this.getDate();
    const res = await this.AnnouncementInstance.FetchAnnouncement({ type: 'agent' });
    if (res.code) {
      this.checkError(res);
    } else {
      this.AnnounceList = await this.AnnouncementInstance.announcementList
        .filter((item) => item.isActive)
        .map((item) => (item.content[this.$i18n.locale]
          ? item.content[this.$i18n.locale]
          : item.content))
        .join(' | ');
    }
  }

  async onLogout() {
    await this.AuthInstance.Logout();
    this.$router.push('/login');
  }

  getDate() {
    const refreshToken: any = jwt_decode(Vue.prototype.$session.get('ambgames-user-refresh-token'));
    const expiredToken = refreshToken.exp * 1000;
    const currentTime = new Date().getTime();
    if (currentTime >= expiredToken) {
      this.onLogout();
    } else {
      setTimeout(() => {
        this.getDate();
      }, 60000);
    }
  }
}
